import { of } from "rxjs";
import { Producer } from '../../models/producer.model';
var StubProducerService = /** @class */ (function () {
    function StubProducerService() {
    }
    StubProducerService.prototype.getProducersInfoByCurrentUser = function () {
        return of();
    };
    StubProducerService.prototype.producerByProducerCode = function () {
        return of();
    };
    StubProducerService.prototype.getByUserID = function () { };
    Object.defineProperty(StubProducerService.prototype, "currentProducerValue", {
        get: function () { return new Producer(); },
        enumerable: true,
        configurable: true
    });
    StubProducerService.prototype.getFormattedProducerCode = function () { };
    StubProducerService.prototype.getProducerHigherRole = function () { };
    return StubProducerService;
}());
export { StubProducerService };
